module.exports = function() {
  return new Worker(__webpack_public_path__ + "1b17ba19f1b3c38b16b4.worker.js");
};